import {ScrollSmoother} from "gsap/ScrollSmoother";

global.$ = global.jQuery = require('jquery');

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import Headroom from "headroom.js";

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
window.Swiper = Swiper;

import AOS from 'aos';
import 'aos/dist/aos.css';

import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
$(document).ready(function() {

    gsap.registerPlugin(ScrollTrigger);
    AOS.init({
        delay: 400,
        duration: 800,
        once: true,
    });

    if (window.location.hash) {
        setTimeout(function() {
            const target = document.querySelector(window.location.hash);
            if (target) {
                target.scrollIntoView({ behavior: 'smooth' });
            }
        }, 700);
    }

    // sticky scroll menu
    const header = $('header');
    let offSet = $('.home-swiper').innerHeight()
    let fromTop = ($(window).scrollTop())
    let beforeAfterImg =$('.box-before-after .img');
    beforeAfterImg.css('background-size' , $(".box-before-after").width()+'px')
    window.onresize = function() {
        offSet = $('.home-swiper').innerHeight()
        beforeAfterImg.css('background-size' , $(".box-before-after").width()+'px')
        setHead()
    }
    setHead()
    function setHead(){
        header.removeClass('header--std');
        if (header.attr('data-type') === 'header--home') {
            if (fromTop >= offSet){
                header.removeClass(header.attr('data-type'));
            } else {
                header.addClass(header.attr('data-type'));
            }
            window.onscroll = function () {
                fromTop = ($(window).scrollTop())
                if (fromTop >= offSet){
                    header.removeClass(header.attr('data-type'));
                    header.addClass('header--std');
                } else {
                    header.addClass(header.attr('data-type'));
                    header.removeClass('header--std');
                }
            };
        } else {
            header.addClass('header--std');
        }
    }

    if($('.headroom').length > 0){
        let headroomEl = document.querySelector("header");
        let options = {
            offset : 100,
        }
        let headroom  = new Headroom(headroomEl,options);
        headroom.init();
    }

    // To-top button
    const toTopBtn = $('#to-top');
    $(window).scroll(function(){
        if ($(window).scrollTop() > 300) {
            toTopBtn.fadeIn();
        } else {
            toTopBtn.fadeOut();
        }
    });

    toTopBtn.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 'slow');
    });

    let burgerButton = $('.burger-button');
    let exit = $('#exit');
    burgerButton.on('click', function(e) {
        e.preventDefault();
        toggleMenuOpenClose();
    });

    exit.on('click', function(e) {
        e.preventDefault();
        toggleMenuOpenClose();
    });

    function toggleMenuOpenClose() {
        let body = $('body');
        let headerNavWrapper = $('#mobile-menu');
        if (headerNavWrapper.hasClass('open')) {
            body.removeClass('no-scroll-y');
            headerNavWrapper.removeClass('open');
            burgerButton.show();
            exit.hide();
        } else {
            body.addClass('no-scroll-y');
            headerNavWrapper.addClass('open');
            burgerButton.hide();
            exit.show();
        }
        // $('#burger-button i').toggleClass("fa-bars fa-x");
    }

    let movCol = $('.mov-col.active');

    movCol.on('mouseenter', function () {
        if (!$(this).hasClass('open')){
            movCol.removeClass('open');
            $(this).addClass('open');
        }
    })

    /* Parallax per immagini */
    if ($(".img-parallax").length > 0) {
        gsap.utils.toArray('.img-parallax').forEach(container => {
            const imgInside = container.querySelector('img');
            const offsetParallax = 10;

            if (imgInside) {
                const tl_parallax = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        scrub: true,
                        pin: false,
                    }
                });

                tl_parallax.fromTo(imgInside, {
                    yPercent: offsetParallax * -1,
                    ease: 'none'
                }, {
                    yPercent: offsetParallax,
                    ease: 'none'
                });
            }
        });
    }

    /* Parallax per immagini di background */
    if ($(".bg-parallax").length > 0) {
        gsap.utils.toArray('.bg-parallax').forEach(container => {
            const offsetParallax = 10;

            gsap.fromTo(container, {
                backgroundPosition: "50% 0%"
            }, {
                backgroundPosition: "50% 100%",
                ease: 'none',
                scrollTrigger: {
                    trigger: container,
                    scrub: true,
                    pin: false,
                }
            });
        });
    }

    let mobileFooterOpener = $('#mobileFooterOpener')
    let footerInfos = $('#footerInfos')

    mobileFooterOpener.click(function (e) {
        e.preventDefault()
        if (mobileFooterOpener.hasClass('open')) {
            footerInfos.stop().slideUp(300);
            mobileFooterOpener.removeClass('open')
        } else {
            footerInfos.stop().slideDown(300);
            mobileFooterOpener.addClass('open')
            let n = $(document).height();
            // console.log(n)
            $('html, body').animate({scrollTop: n}, 200);
        }
    })
});
